const validateHomeAddress = values => {
    if (values.homeAddressInput == null || values.homeAddressInput === '') {
        return { homeAddressInput: 'Invalid address' };
    }
    return {};
};

const validatePostalCode = values => {
    if (values.postalCodeInput == null || values.postalCodeInput === '') {
        return { postalCodeInput: 'Invalid postal code' };
    }
    return {};
};

const validate = values => {
    const errors = {
        ...validateHomeAddress(values),
        ...validatePostalCode(values)
    };

    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/LocalRep/Form/validations.js